firebird.controller('meetingSettingsCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    '$state',
    'logService',
    'meetingService',
    'attendeeService',
    'helperService',
    'configService',
    'localizationService',
    'betaSettingsService',
    'analyticsWrapperService',
    'subscriptionService',
    'userPairStateService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        $state,
        logService,
        meetingService,
        attendeeService,
        helperService,
        configService,
        localizationService,
        betaSettingsService,
        analyticsWrapperService,
        subscriptionService,
        userPairStateService
    ) {
        var self = this;
        let rootSubscription;

        self.modalState = 'closed';
        self.currentActiveTab = null;
        self.isSaving = false;

        self.isCustomBrandingEnabled = attendeeService.getIsHost() && meetingService.hasFeature('branding');
        self.isElectron = helperService.isElectron();
        self.sfuEnabled = meetingService.getIsSfuEnabled();
        self.hasFeatureFlags = configService.getHasFeatureFlags();

        self.cleanUp = cleanUp;
        self.closeModal = closeModal;
        self.setActiveTab = setActiveTab;
        self.canSetActiveTab = canSetActiveTab;
        self.showHideFeatureFlags = showHideFeatureFlags;
        self.sendFeedback = sendFeedback;
        self.shouldShowSecuritySettings = shouldShowSecuritySettings;
        self.shouldShowVirtualAssistant = shouldShowVirtualAssistant;
        self.shouldDisableVirtualAssistant = shouldDisableVirtualAssistant;
        self.getVirtualAssistantTooltip = getVirtualAssistantTooltip;
        self.shouldShowVirtualBackground = shouldShowVirtualBackground;
        self.shouldDisableVirtualBackground = shouldDisableVirtualBackground;
        self.getVirtualBackgroundTooltip = getVirtualBackgroundTooltip;

        self.shouldShowBeta = shouldShowBeta;
        self.VDIRef = helperService.getVDIRef();

        self.isCompactMode = false;

        initSubscriptions();

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        init();

        ////////////////////////

        function init() {
            betaSettingsService.init();
        }

        function onShowModal(e, modalName, tabName) {
            if (modalName === 'meetingSettings') {
                self.modalState = 'open';

                // Default tab
                var tab = 'av-settings';

                if (tabName) {
                    switch (tabName) {
                        case 'custom-branding':
                            if (self.isCustomBrandingEnabled) {
                                tab = tabName;
                            }
                            break;
                        case 'virtual-background':
                            if (self.shouldShowVirtualBackground()) {
                                tab = tabName;
                            }
                            break;
                        case 'virtual-assistant':
                            if (self.shouldShowVirtualAssistant()) {
                                tab = tabName;
                            }
                            break;
                        case 'security-settings':
                            if (self.shouldShowSecuritySettings()) {
                                tab = tabName;
                            }
                            break;
                        case 'beta-settings':
                            if (self.shouldShowBeta()) {
                                tab = tabName;
                            }
                            break;
                        case 'general-settings':
                            tab = tabName;
                            break;
                        case 'advanced-settings':
                            tab = tabName;
                            break;
                        case 'about-settings':
                            tab = tabName;
                            break;
                    }
                }

                //Clicking on a tab will have the same effect as $state.go('tab-name'),
                //but we call it manually here to open av-settings as default tab
                $state.go('meeting-active.' + tab);

                self.setActiveTab(tab);

                analyticsWrapperService.eventTrack('Meeting - Opened Settings Modal', {
                    category: 'Meeting Settings'
                });

                digest();
            }
        }

        //Closed via broadcasted event
        function onHideModal(e, modalName) {
            if (modalName.indexOf('meetingSettings') !== -1) {
                self.cleanUp();
                digest();
            }
        }

        //Closed via Cancel or Save buttons
        function closeModal(applyChanges, immediate) {
            logService.log('meetingSettingsCtrl - closing modal... applying changes:', applyChanges);

            if (applyChanges) {
                self.isSaving = true;
            }

            $timeout(
                function () {
                    $rootScope.$broadcast('settings-modal-closed', {
                        applyChanges: applyChanges
                    });

                    $window.$('#meetingSettings').modal('hide');

                    self.cleanUp();

                    if (!applyChanges) {
                        analyticsWrapperService.eventTrack('Meeting - Clicked Cancel in Settings Modal', {
                            category: 'Meeting Settings'
                        });
                    }
                },
                immediate ? 0 : 1000
            );
        }

        function cleanUp() {
            self.modalState = 'closed';
            self.currentActiveTab = null;
            self.isSaving = false;
            digest();
        }

        function setActiveTab(tabName) {
            if (!self.canSetActiveTab(tabName)) {
                return;
            }

            logService.log('meetingSettingsCtrl - Setting active tab: ' + tabName);

            $rootScope.$broadcast('settings-view-state-change', {
                openedTab: tabName,
                closedTab: self.currentActiveTab
            });

            self.currentActiveTab = tabName;

            //Empty timeout added in order for the element classes to get modified at the end of a digest cycle
            //(ensures the elements are on the page before modifying)
            $timeout(function () {
                $window.$('.settings-content-view').removeClass('active');
                $window.$('.settings-content-view.' + tabName).addClass('active');
            });
        }

        function canSetActiveTab(tabName) {
            if (self.currentActiveTab === tabName) {
                return false;
            }

            if (tabName === 'virtual-background' && self.shouldDisableVirtualBackground()) {
                return false;
            }

            if (tabName === 'virtual-assistant' && self.shouldDisableVirtualAssistant()) {
                return false;
            }

            return true;
        }

        function showHideFeatureFlags() {
            self.closeModal(false, true);
            if (helperService.getIsRedesign()) {
                $rootScope.$broadcast('showhide-feature-flags');
            }
        }

        function shouldShowSecuritySettings() {
            return meetingService.getMeetingSecuritySettingsEnabled() && attendeeService.getIsHost();
        }

        function shouldShowVirtualAssistant() {
            return !meetingService.isWebinar() && meetingService.hasTranscriptionEnabled();
        }

        function shouldDisableVirtualAssistant() {
            return meetingService.e2eeEnabled();
        }

        function getVirtualAssistantTooltip() {
            return meetingService.e2eeEnabled()
                ? localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_VIRTUAL_ASSISTANT_DISABLED')
                : '';
        }

        function shouldShowVirtualBackground() {
            return (
                !meetingService.isWebinar() &&
                meetingService.getVirtualBackgroundEnabled() &&
                self.VDIRef.showVirtualBackgroundOption
            );
        }

        function shouldDisableVirtualBackground() {
            return meetingService.e2eeEnabled();
        }

        function getVirtualBackgroundTooltip() {
            return meetingService.e2eeEnabled()
                ? localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_VIRTUAL_BACKGROUND_DISABLED')
                : '';
        }

        function shouldShowBeta() {
            return betaSettingsService.shouldShowBetaTab();
        }

        function sendFeedback() {
            logService.log('meetingSettingsCtrl - Send feedback');
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
        }
    }
]);
